<template>
  <div>
    <Frontendlayout>
      <section class="hero_in tours">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span>My Offers</h1>
          </div>
        </div>
      </section>
      <!--/hero_in-->
      <div class="bg_color_1">
        <div class="container-fluid margin_60_35">
          <div class="row">
            <Sidebar />

            <div class="col-lg-10">
              <div class="box_cart">
                <div v-show="loading">
                  <div data-loader="circle-side"></div>
                </div>
                <form autocomplete="off" method="post" class="form-horizontal">
                  <div class="row">
                    <div class="col-md-3">
                      <div class="form-group">
                        <label>Status</label>
                        <select v-model="search.is_active" class="form-control">
                          <option value="">-Select-</option>
                          <option value="2" selected="selected">
                            -Waiting for approval-
                          </option>
                          <option value="1">-Approved-</option>
                          <option value="3">-Rejected-</option>
                          <option value="0">-Deleted-</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-4" style="margin-top: 32px">
                      <div class="form-group">
                        <label><br /></label>
                        <button
                          type="button"
                          @click.prevent="getOffers()"
                          class="btn_1"
                        >
                          Filter
                        </button>
                      </div>
                    </div>
                    <div class="col-md-5" style="margin-top: 32px; float:right;">
                      <router-link
                        class="btn btn-success pull-right"
                        to="/create-offers"
                      >
                        <span class="nav-link-text">New Offers</span>
                      </router-link>
                    </div>
                  </div>
                </form>
                <table class="table table-striped cart-list">
                  <thead>
                    <tr>
                      <th>Sr No</th>
                      <th>Category</th>
                      <th>Title</th>
                      <th>offer in</th>
                      <th>offer value</th>
                      <th>Location</th>
                      <th>Pincode</th>
                      <th>Validity</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(offer, index) in offers" :key="offer.id">
                      <th>{{ index + 1 }}</th>
                      <td>
                        <div
                          v-for="categories in offer.offer_categories"
                          :key="categories.id"
                        >
                          <span class="badge badge-success">{{
                            categories.category
                          }}</span>
                        </div>
                      </td>
                      <td>
                        <strong>{{ offer.short_description }}</strong>
                      </td>
                      <td>
                        <strong>{{ offer.offer_in }}</strong>
                      </td>
                      <td>{{ offer.offer_value }}</td>
                      <td>
                        <strong>{{ offer.location }}</strong>
                      </td>
                      <td>
                        <strong>{{ offer.pincode }}</strong>
                      </td>
                      <td>
                        <strong
                          >{{ offer.valid_from }} -
                          {{ offer.valid_till }}</strong
                        >
                      </td>
                      <td class="options" style="width: 5%; text-align: center">
                        <a
                          href="javascript:void(0); "
                          @click="redirect(offer.id, 'view-offer')"
                          ><i class="fa fa-eye"></i></a
                        >&nbsp;&nbsp;
                        <a
                          href="javascript:void(0); "
                          @click="redirect(offer.id, 'update-offer')"
                          v-show="offer.is_active == 2"
                          v-if="display_edit(offer.valid_till)"
                          ><i class="fa fa-pencil"></i> </a
                        >&nbsp;&nbsp;
                        <a
                          href="javascript:void(0); "
                          @click="redirect(offer.id, 'delete-offer')"
                          v-show="offer.is_active == 2"
                          ><i class="fa fa-trash"></i
                        ></a>

                        <a
                          href="javascript:void(0); "
                          @click="redirect(offer.id, 'offer-images')"
                          v-show="offer.is_active != 1"
                          >Upload Images</a
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>

                <!-- /cart-options -->
              </div>
            </div>
            <!-- /col -->
          </div>
          <!-- /row -->
        </div>
        <!-- /container -->
      </div>
      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>

<script>
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import router from "../routes";
import API from "../services/index.js";
import Frontendlayout from "../layouts/Frontendlayout.vue";
// import Cards from "../cmps/Cards.vue"
import Sidebar from "../layouts/Sidebar.vue";
import $ from "jquery";

export default {
  data() {
    return {
      token: "Bearer " + localStorage.getItem("token"),
      offers: [],
      msg: null,
      classAlert: null,
      loading: false,
      dt: null,
      search: {
        is_active: "",
      },
    };
  },
  components: {
    Frontendlayout,
    Sidebar,
  },
  beforeMount() {
    //this.getOffers();
    // this.createVendorservices()
  },

  methods: {
    display_edit(offer_till_date) {
      //var currentDate = new Date();
      //alert(currentDate);
      var currentDateWithFormat = new Date()
        .toJSON()
        .slice(0, 10)
        .replace(/-/g, "-");
      //alert(currentDateWithFormat >= offer_till_date);
      if (currentDateWithFormat >= offer_till_date) return false;
      else return true;
    },
    redirect(offerid, url) {
      router.push(url + "/" + window.btoa(offerid));
    },
    getOffers() {
      // alert(this.token);
      this.loading = true;
      const role_id = localStorage.getItem("role_id");
      const form = new FormData();
      form.append("role_id", role_id);
      form.append("search", JSON.stringify(this.search));

      API.post("/offer/get_offer_by_vendorId", form, {
        headers: { Authorization: this.token },
      })
        .then((res) => {
          this.loading = false;
          this.dt = $(".table").DataTable();

          setTimeout(() => (this.offers = res.data.data));
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
  },
  watch: {
    offers(val) {
      console.log(val);
      this.dt.destroy();

      this.$nextTick(() => {
        this.dt = $(".table").DataTable();
      });
    },
  },
  mounted() {
    this.getOffers();
  },
};
</script>

<style  scoped>
@media (max-width: 991px) {
  .table.cart-list td:nth-of-type(1):before,
  .table.cart-list td:nth-of-type(2):before,
  .table.cart-list td:nth-of-type(3):before,
  .table.cart-list td:nth-of-type(4):before,
  .table.cart-list td:nth-of-type(5):before,
  .table.cart-list td:nth-of-type(6):before {
    font-weight: 600;
    color: #111;
  }

  .table.cart-list td:nth-of-type(1):before {
    content: "Category";
  }

  .table.cart-list td:nth-of-type(2):before {
    content: "Offer In";
  }

  .table.cart-list td:nth-of-type(3):before {
    content: "Offer Value";
  }

  .table.cart-list td:nth-of-type(4):before {
    content: "Location";
  }
  .table.cart-list td:nth-of-type(5):before {
    content: "Pincode";
  }

  .table.cart-list td:nth-of-type(6):before {
    content: "Valid Till";
  }

  .table.cart-list td:nth-of-type(7):before {
    content: "Actions";
  }
}
</style>